import React from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { FormattedMessage } from "react-intl";
import "react-datepicker/dist/react-datepicker.css";
import config from "../../../helpers/config.helper";

const appConfig = config();
const dateTimeFormat = appConfig.REACT_APP_DATE_TIME_FORMAT;

type PropsType = {
  input: any;
  minDate?: string;
  disabled?: boolean;
  meta: {
    touched: boolean;
    error?: string;
  };
};

const DateTimeCustomPicker = ({ input, minDate, disabled, meta }: PropsType) => {

  const handleChange = (date: Date | null) => {
    if (!date) {
      input.onChange(null);
      return;
    }

    input.onChange(moment(date).format(dateTimeFormat));
  };

  const selectedDate =
    input.value && moment(input.value, dateTimeFormat, true).isValid()
      ? moment(input.value, dateTimeFormat).toDate()
      : null;

  return (
    <div className="form-group">
      <DatePicker
        selected={selectedDate}
        onChange={handleChange}
        dateFormat="yyyy-MM-dd HH:mm"
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={5}
        timeCaption="Time"
        disabled={disabled}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        minDate={minDate ? new Date(minDate) : undefined}
        maxDate={new Date()}
        className="form-control"
        placeholderText="YYYY-MM-DD HH:mm"
        isClearable
      />

      {meta.touched && meta.error && (
        <span className="text-danger errorMessage">
          <FormattedMessage id={meta.error} />
        </span>
      )}
    </div>
  );
};

export default DateTimeCustomPicker;